import * as React from 'react'
import Parcel from 'single-spa-react/lib/esm/parcel' // https://github.com/single-spa/single-spa-react/releases/tag/v3.0.0
import type { ParcelCompProps } from 'single-spa-react/parcel'
import './styles.scss'

export const SingleSpaParcel = (props: ParcelCompProps) => <Parcel {...props} />
